import MemegorList from '../Data/MemegorList'
function Memegor() {

    return (
        <>
        {/* Meme Goreng Merch */}
            <div className="w-full lg:h-96 md:60 48 rounded-3xl my-20">
                <a href="/merch">
                <img src ="/img/memegoreng.jpg" className="w-full h-full object-cover rounded-3xl" alt="" />
                </a>
            </div>
            <div>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-10 py-10 mb-10">
                    {/* List */}
                    {MemegorList.map((Memegor) => (
                    <a href={Memegor.link}>
                    <div className="py-5 px-5 hover:bg-slate-200 hover:scale-90 duration-500 rounded-3xl">
                        <div className="flex flex-col gap-5">
                            <div className="w-full h-full">
                                <img src ={Memegor.img} className="w-full h-full object-cover rounded-3xl" alt="" />
                            </div>
                            <div className="flex flex-col">
                                <div className="text-3xl font-mono py-5  ">{Memegor.title}<br /> <br /> <span className="my-5 py-3 px-3 rounded-full bg-red-300 text-red-700 my-5">{Memegor.prices}</span></div>
                                <div className="text-base font-mono py-3"><span className="py-3 px-3 rounded-full bg-green-300 text-green-700 my-5">{Memegor.category}</span></div>
                                <div className="text-md font-mono py-6">{Memegor.desc}</div>
                                <div className="py-5"><span className="text-3xl font-mono my-5 py-3 px-8 bg-rose-800 rounded-full text-white">Learn More!</span></div>
                            </div>
                        </div>
                    </div>
                    </a>
                    ))}
                </div>    
            </div>
        </>
    )
}

export default Memegor;